import { render, staticRenderFns } from "./RepresentativesCreate.vue?vue&type=template&id=02768366"
import script from "./RepresentativesCreate.vue?vue&type=script&lang=ts"
export * from "./RepresentativesCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports